import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/containers_inspect_graphs/agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchExporterQualityTemplate(agro_exporter_process_id, exporter_process_quality_template_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/containers_inspect_graphs/${agro_exporter_process_id}/quality_template/${exporter_process_quality_template_id}`
    );
  },
  fetchContainers(agro_exporter_process_id, exporter_process_quality_template_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/containers_inspect_graphs/${agro_exporter_process_id}/quality_template/${exporter_process_quality_template_id}/containers`
    );
  }
};
